import React from "react";
import { StyleSheet, Text, View } from "react-native";
import { ListItem, Avatar } from "react-native-elements";
import { db } from "../firebase";

const ChatCard = ({ chat, chat_screen }) => {
  var id = chat.id;
  var chat_name = chat.data.chat_name;

  const [recent_message, set_recent_message] = React.useState("");

  db.collection("chats")
    .doc(id)
    .collection("messages")
    .orderBy("timestamp", "desc")
    .onSnapshot((snapshot) => {
      set_recent_message(snapshot.docs[0]?.data()?.message);
    });

  return (
    <ListItem key={id} bottomDivider onPress={() => chat_screen(id, chat_name)}>
      <Avatar
        rounded
        source={{
          uri: "https://i.pravatar.cc/150",
        }}
      />
      <ListItem.Content>
        <ListItem.Title style={{ fontWeight: 800 }}>{chat_name}</ListItem.Title>
        <ListItem.Subtitle numberOfLines={1} ellipsizeMode="tail">
          {recent_message}
        </ListItem.Subtitle>
      </ListItem.Content>
    </ListItem>
  );
};

export default ChatCard;

const styles = StyleSheet.create({});
